export default "__VITE_ASSET__a2514a87__"